(() => {
  'use strict';
  function update(group) {
    if (!group) return;
    const selected = group.querySelector('input[name="attributes[Kundenart]"]:checked');
    const isBusiness = selected?.value === 'Geschaeftskunde';
    const details = group.querySelector('[data-bp-business-details]');
    const company = group.querySelector('[data-bp-business-company]');
    const confirm = group.querySelector('[data-bp-business-confirm]');
    const attestation = group.querySelector('[data-bp-business-attestation]');
    if (details) details.hidden = !isBusiness;
    if (company) {
      company.required = isBusiness;
      if (!isBusiness) company.value = '';
    }
    if (confirm) {
      confirm.required = isBusiness;
      if (!isBusiness) confirm.checked = false;
    }
    if (attestation) attestation.value = isBusiness && confirm?.checked ? 'Ja' : '';
  }
  function syncAll() {
    document.querySelectorAll('[data-bp-customer-type]').forEach(update);
  }
  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target?.matches?.('input[name="attributes[Kundenart]"],[data-bp-business-confirm]')) return;
    update(target.closest('[data-bp-customer-type]'));
  }, true);
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node.nodeType === 1 && (node.matches?.('[data-bp-customer-type]') || node.querySelector?.('[data-bp-customer-type]'))
    ))) syncAll();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true});
  syncAll();
})();
